define.alias("shared/components/shared/ai-credits/info", "settings/components/shared/ai-credits/info");